const SUBSTITUTE = '…';
/**
 * Обрезает строку под максимальную длину, вырезая последние символы и заменяя их на заданную строку.
 * По умолчанию удалённые символы заменяются на ...
 * Если изначальная строка проходит по длине – она не меняется.
 *
 * @param value Строка, которую нужно обрезать
 * @param maxLength Максимальная длина результирующей строки
 * @param substitute Строка, на которую нужно заменить удалённые символы
 * @returns Строка не длиннее максимальной длины
 *
 * @example
 * ```typescript
 * import { maxLengthCut } from '@direct-frontend/stdlib';
 *
 * maxLengthCut('a'.repeat(50), 10); // 'aaaaaaaaa…'
 * ```
 **/
export function maxLengthCut(value, maxLength, substitute = SUBSTITUTE) {
    if (value.length <= maxLength) {
        return value;
    }
    return `${value.slice(0, maxLength - substitute.length)}${substitute}`;
}
